module.exports = __webpack_public_path__ + "static/media/Fitmonkie_3_Element Seamless Leggings (Tall).5ed91c87.jpeg";